import React from 'react';
import { Link } from 'react-router-dom';
import { AiOutlineFullscreen, AiOutlineFullscreenExit, AiOutlineSetting } from 'react-icons/ai';
import LogoNavbar from '../HomeNavbar/LogoNavbar.jsx';
import DarkModeToggle from '../HomeNavbar/DarkMode/index.jsx';

// Barra superior (logo + dropdown de pantalla completa/modo oscuro) idéntica
// entre Public3dViewer.jsx y Mi3DViewer.jsx; solo cambia el texto al pie del
// dropdown (`subtitle`).
const TopBar = ({ theme, fullscreenActive, fullscreenToggle, subtitle }) => (
    <div className="absolute top-0 left-0 right-0 z-50 flex items-center justify-between px-4 py-3 pointer-events-none">
        {/* Logo */}
        <Link to="/" className="pointer-events-auto flex items-center">
            <LogoNavbar themeContext={theme} />
        </Link>

        {/* Settings dropdown */}
        <div className="dropdown dropdown-end pointer-events-auto">
            {/* El tooltip va en un wrapper: combinar tooltip + btn-circle en el
                mismo elemento descoloca el icono (DaisyUI). */}
            <div className="tooltip tooltip-left" data-tip="Configuración">
                <label
                    tabIndex={0}
                    className="btn btn-sm btn-ghost btn-circle bg-base-100/80 backdrop-blur border border-base-300/60 grid place-content-center p-0 leading-none"
                >
                    <AiOutlineSetting size={18} className="block" />
                </label>
            </div>

            <div
                tabIndex={0}
                className="dropdown-content menu p-3 shadow-2xl bg-base-100 rounded-2xl w-56 border border-base-300/60 mt-2"
            >
                <div className="px-2 pb-2 mb-1 border-b border-base-300">
                    <p className="text-xs font-semibold text-base-content/60 uppercase tracking-wide">
                        Configuración
                    </p>
                </div>

                <ul className="space-y-1 mt-1">
                    <li>
                        <button
                            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-base-content hover:bg-base-200 transition-colors duration-150"
                            onClick={(e) => { e.stopPropagation(); fullscreenToggle(); }}
                        >
                            <span className="p-1.5 rounded-lg bg-base-300">
                                {fullscreenActive
                                    ? <AiOutlineFullscreenExit size={16} />
                                    : <AiOutlineFullscreen size={16} />
                                }
                            </span>
                            <span className="flex-1 text-left">
                                {fullscreenActive ? 'Salir pantalla completa' : 'Pantalla completa'}
                            </span>
                        </button>
                    </li>

                    <li>
                        <div
                            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-base-content hover:bg-base-200 transition-colors duration-150 cursor-default"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <span className="p-1.5 rounded-lg bg-base-300">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                        d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                                </svg>
                            </span>
                            <span className="flex-1 text-left">Modo oscuro</span>
                            <DarkModeToggle />
                        </div>
                    </li>
                </ul>

                <div className="mt-2 pt-2 border-t border-base-300">
                    <p className="text-xs text-base-content/40 text-center">{subtitle}</p>
                </div>
            </div>
        </div>
    </div>
);

export default TopBar;
